"use client";

import { MapPin, Clock, Navigation } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Locatiekaart() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  return <section ref={ref} className="relative min-h-[600px] w-full overflow-hidden bg-cover bg-center bg-fixed bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1511866/img/ekonorm_brussels_location_map.png)]">
      {}
      <div className="absolute inset-0 bg-dark-background/40" />

      {}
      <div className="relative flex min-h-[600px] items-center justify-center px-4 py-24">
        <div className={`glass-effect max-w-md w-full px-8 py-10 shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {}
          <div className="mb-6 flex items-start gap-4">
            <MapPin className="mt-1 size-5 shrink-0 text-primary" />
            <div>
              <h3 className="mb-1 text-lg font-semibold text-foreground">Adres</h3>
              <p className="text-sm leading-relaxed text-muted-foreground">Industriepark West 75 Sint-Niklaas</p>
            </div>
          </div>

          {}
          <div className="mb-8 flex items-start gap-4">
            <Clock className="mt-1 size-5 shrink-0 text-foreground" />
            <div>
              <h3 className="mb-1 text-lg font-semibold text-foreground">Openingsuren</h3>
              <p className="text-sm leading-relaxed text-muted-foreground">
                Ma-Vr: 08:00 - 18:00
              </p>
            </div>
          </div>

          {}
          <Link to="https://www.google.com/maps/place/Grote+Kerkstraat+123,+1000+Brussel" newTab>
            <Button className="w-full bg-primary text-foreground-primary hover:bg-primary-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-primary-active active:translate-y-0 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
              <Navigation className="size-4" />
              Route plannen
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}